var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCryptoCardBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 500,
    viewBox: "0 0 429 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_232)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_565_232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.699 465.338C300.072 465.338 367.66 398.408 367.66 315.845C367.66 233.282 300.072 166.351 216.699 166.351C133.326 166.351 65.7389 233.282 65.7389 315.845C65.7389 398.408 133.326 465.338 216.699 465.338ZM216.699 465.338H-85.2214M85.864 240.906C44.1775 312.408 68.9161 403.837 141.119 445.119C213.323 486.4 305.648 461.902 347.335 390.4C389.022 318.898 364.283 227.469 292.08 186.188C219.876 144.906 127.551 169.405 85.864 240.906ZM85.864 240.906L236.824 -18.0244M347.338 241.004C305.651 169.503 213.325 145.004 141.122 186.286C68.9189 227.568 44.1802 318.996 85.8668 390.498C127.553 462 219.879 486.498 292.082 445.217C364.286 403.935 389.024 312.506 347.338 241.004ZM347.338 241.004L498.298 499.935",
    stroke: "#21C3E7",
    strokeOpacity: 0.2,
    strokeWidth: 75.5358,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_232"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.026123,
    width: 428.571,
    height: 500,
    rx: 38.6231,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_565_232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 428.571,
    height: 500,
    fill: "white",
    transform: "translate(0.0268555)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoCardBg);
export default __webpack_public_path__ + "static/media/cryptoCardBg.6c099ec942c02a66e6b75681b45015a8.svg";
export { ForwardRef as ReactComponent };